(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
if (!customElements.get('rta-offer-banner')) {
  customElements.define('rta-offer-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('.rta-offer-banner__offer'));
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('.rta-offer-banner__controls').hidden = false;
      this.showOffer(0);
      this.updatePause();
      this.querySelector('[data-previous]').addEventListener('click', () => this.showOffer(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.showOffer(this.index + 1), options);
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.addEventListener('focusin', () => { this.focused = true; }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); }, options);
      this.timer = window.setInterval(() => {
        if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.showOffer(this.index + 1);
      }, 7000);
    }
    showOffer(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }
    updatePause() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Resume offer rotation' : 'Pause offer rotation');
      this.pauseButton.textContent = this.paused ? '\u25b6' : '\u275a\u275a';
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
